<template>
  <div :style="bgColor">
    <Loader :visible="loading"></Loader>
    <section>
      <img :src="organizator.banner_url" class="banner" />
      <h3 class="minisite-title" :style="textColor">{{organizator.title}}</h3>
      <div class="container">
        <div v-if="hasEvents" class="row">
          <div class="col-md-4 col-lg-3" v-for="event in events" :key="event.id">
            <div class="event-card card">
              <a :href="event.external_url" v-if="event.external">
                <img :src="event.logo_url" class="card-img-top" alt="event.name" />
              </a>
              <router-link :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}" v-if="!event.external">
                <img :src="event.logo_url" class="card-img-top" alt="event.name" />
              </router-link>
              <div class="card-body">
                <div class="row" v-if="event.external">
                  <div class="col-lg-7 col-7">
                    <a :href="event.external_url">
                      <p class="name">{{ event.name }}</p>
                    </a>
                    <p class="date">{{ event.event_at | toLongDate }}</p>
                  </div>
                </div>

                <div class="row" v-if="!event.external">
                  <div class="col-lg-7 col-7">
                    <router-link :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}">
                      <p class="name">{{ event.name }}</p>
                    </router-link>
                    <p class="date">{{ event.event_at | toLongDate }}</p>
                  </div>
                  <div class="col-lg-5 col-5">
                    <div align="right" v-if="event.sale">
                      <div class="cart" @click="addToCart(event.identifier)">
                        <i class="fas fa-shopping-cart"></i>
                      </div>
                      <div v-if="event.active_pre_order">
                        <p class="price" v-if="event.price_album === 0"></p>
                        <p class="price" v-else>{{event.pre_order_item.discount_price | toCurrency}}</p>
                      </div>
                      <div v-else>
                        <p class="price" v-if="event.price_album === 0"></p>
                        <p class="price" v-else>{{ event.price_album | toCurrency }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-md-12" v-show="!loading">
            <div class="alert alert-primary" role="alert">
              {{$t("events.notFound")}}
            </div>
          </div>
        </div>
        <div class="row mb-50" v-show="!loading && more">
          <div class="col-lg-12">
            <div align="center">
              <button @click="nextPage" class="button-plus">
                {{$t("events.loadMore")}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loader from '../../components/Loader';
import Organizator from '../../models/Organizator';

export default {
  name: "Events",
  data() {
    return {
      page: 1,
      events: [],
      loading: true,
      organizator: new Organizator(),
      organizatorId: ""
    }
  },
  components: {
    Loader
  },
  async created() {
    this.organizatorId = this.$route.params.organizator
    const organizator = await this.fetchOrganizator()
    this.organizator = new Organizator(organizator)
    this.getEvents()
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),

    async fetchOrganizator() {
      try {
        const response = await this.$http.get(`/api/v2/organizators/${this.organizatorId}`)

        if(response.status == 200 || response.status == 304) {
          return response.data.organizator
        } else {
          return []
        }
      } catch (e) {
        location.href = "/"
        console.log(e)
      }
    },
    async fetch() {
      try {
        const response = await this.$http.get(`/api/v2/minisites/${this.organizatorId}`, {
          params: {page: this.page}
        })

        if(response.status == 200 || response.status == 304) {
          return response.data.events
        } else {
          return []
        }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async getEvents() {
      this.loading = true
      const events = await this.fetch()
      this.events.push.apply(this.events, events)
      this.loading = false
    },
    async nextPage() {
      this.page = parseInt(this.page) + 1
      await this.getEvents()
    },
    async addToCart(eventId) {
      const params = { event_id: eventId, photo_id: null };
      this.$alertify.success(this.$t("checkout.addedItem"));
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params);
    }
  },
  computed: {
    hasEvents() {
      return this.events.length > 0
    },
    more() {
      return this.events.length > 0
    },
    bgColor() {
      return `background-color: ${this.organizator.primary_color}`
    },
    textColor() {
      return `color: ${this.organizator.secondary_color}`
    },
  }
}
</script>

<style lang="scss">
  .minisite-title {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 26px;
    font-size: 35px;
  }
</style>
